/* eslint-disable import/prefer-default-export */
import { Product, SubscriptionListEntry } from 'ggApp/types/graphql';

import ActionTypes from './actionTypes';

export interface Pagination {
    totalCount?: number;
    pageInfo?: {
        endCursor: string;
        hasNextPage: boolean;
    };
}

export interface PayloadWithPagination extends Pagination {
    filterItems: SubscriptionListEntry[];
}

export interface SetFilterItemsAction {
    type: typeof ActionTypes.SET_FILTER_ITEMS;
    payload: PayloadWithPagination;
}

export interface AppendFilterItemsAction {
    type: typeof ActionTypes.APPEND_FILTER_ITEMS;
    payload: PayloadWithPagination;
}

export interface SetProductAction {
    type: typeof ActionTypes.SET_PRODUCT;
    payload: Product;
}

export interface DeleteProductAction {
    type: typeof ActionTypes.DELETE_PRODUCT;
}

export function setFilterItems(payload: PayloadWithPagination): SetFilterItemsAction {
    return {
        type: ActionTypes.SET_FILTER_ITEMS,
        payload,
    };
}

export function appendFilterItems(payload: PayloadWithPagination): AppendFilterItemsAction {
    return {
        type: ActionTypes.APPEND_FILTER_ITEMS,
        payload,
    };
}

export function setProduct(product: Product): SetProductAction {
    return {
        type: ActionTypes.SET_PRODUCT,
        payload: product,
    };
}

export function deleteProduct(): DeleteProductAction {
    return {
        type: ActionTypes.DELETE_PRODUCT,
    };
}

export type Action =
    | SetFilterItemsAction
    | SetProductAction
    | DeleteProductAction
    | AppendFilterItemsAction;
export type ActionCreator = typeof setFilterItems | typeof setProduct | typeof deleteProduct;
